import masterService from '../../core/services/Common/MasterService';
import userSettingService from '../../core/services/Common/UserSettingService';
import {
  checkIsBank,
  checkIsInsurance,
  formatComGroupCode,
  saveSyncComponentState,
  setSyncComponentSearch,
} from '../helpers/Common';
import { formatData, getListIdAndListObjById } from './../helpers/Api';
import { convertTreeMap } from './../helpers/ArrayUtils';
import { cloneDeep, groupBy } from 'lodash';

export const REDUCER_NAME = 'COMMON:';
const CHANGE_COUNT_COMPONENT = `${REDUCER_NAME}CHANGE_COUNT_COMPONENT`;
const CHANGE_COUNT_POPOUT = `${REDUCER_NAME}CHANGE_COUNT_POPOUT`;
const GET_TIME_OFFSET_SUCCESS = `${REDUCER_NAME}GET_TIME_OFFSET_SUCCESS`;
const SET_TIME_TO_OPEN_MARKET = `${REDUCER_NAME}SET_TIME_TO_OPEN_MARKET`;
const SET_ORGANIZATION = `${REDUCER_NAME}SET_ORGANIZATION`;
const SET_ORGANIZATION_LOADING = `${REDUCER_NAME}SET_ORGANIZATION_LOADING`;
const SET_COMPANY_GROUP = `${REDUCER_NAME}SET_COMPANY_GROUP`;
const SET_INDUSTRY = `${REDUCER_NAME}SET_INDUSTRY`;
const SET_DERIVATIVE = `${REDUCER_NAME}SET_DERIVATIVE`;
const SET_ECONOMY = `${REDUCER_NAME}SET_ECONOMY`;
const SET_COVERED_WARRANT = `${REDUCER_NAME}SET_COVERED_WARRANT`;
const SET_USER_WATCHLIST = `${REDUCER_NAME}SET_USER_WATCHLIST`;
const UPDATE_USER_WATCHLIST = `${REDUCER_NAME}UPDATE_USER_WATCHLIST`;
const DELETE_USER_WATCHLIST = `${REDUCER_NAME}DELETE_USER_WATCHLIST`;

const SET_SYNC_COMPONENT = `${REDUCER_NAME}SET_SYNC_COMPONENT`;
const CHANGE_SYNC_COMPONENT_SEARCH = `${REDUCER_NAME}CHANGE_SYNC_COMPONENT_SEARCH`;
const SET_SYNC_STATE = `${REDUCER_NAME}SET_SYNC_STATE`;

export const changeSyncComponentSearch = payload => ({
  payload,
  type: CHANGE_SYNC_COMPONENT_SEARCH,
});

export const updateUserWatchlist = wl => ({
  type: UPDATE_USER_WATCHLIST,
  payload: wl,
});

export const deleteUserWatchlist = wlId => ({
  type: DELETE_USER_WATCHLIST,
  payload: wlId,
});

export const setSyncComponent = ({ name, id, data }) => ({
  type: SET_SYNC_COMPONENT,
  payload: { name, id, data },
});

export const changeCountComponent = (nameComponent, count) => {
  return {
    type: CHANGE_COUNT_COMPONENT,
    payload: {
      nameComponent,
      count,
    },
  };
};

export const changeCountPopout = (nameComponent, count) => {
  return {
    type: CHANGE_COUNT_POPOUT,
    payload: {
      nameComponent,
      count,
    },
  };
};

export const getTimeOffset = () => dispatch => {
  masterService
    .getTimeOffset()
    .then(diff => {
      const secondDiff = typeof diff === 'number' ? diff : 0;
      dispatch({
        type: GET_TIME_OFFSET_SUCCESS,
        payload: secondDiff,
      });
    })
    .catch(err => {
      dispatch({
        type: GET_TIME_OFFSET_SUCCESS,
        payload: 0,
      });
    });
};

export const setTimeToOpenMarket = seconds => ({
  type: SET_TIME_TO_OPEN_MARKET,
  payload: seconds,
});

export const countDownSecondsToOpenMarket = () => (dispatch, getState) => {
  if (getState()[REDUCER_NAME].secondsToOpenMarket === 0) {
    return;
  }
  const interval = setInterval(() => {
    const secondsToOpenMarket = getState()[REDUCER_NAME].secondsToOpenMarket;
    const seconds = secondsToOpenMarket - 1;
    if (seconds === 0) {
      clearInterval(interval);
    }
    dispatch({
      type: SET_TIME_TO_OPEN_MARKET,
      payload: seconds,
    });
  }, 1000);
};

export const getSecondsToOpenMarket = () => {
  const startCountTime = new Date();
  if (startCountTime.getDay() === 6 || startCountTime.getDay() === 0) {
    return 0;
  }
  startCountTime.setHours(8, 30, 0, 0);
  const openTime = new Date();
  openTime.setHours(8, 45, 0, 0);
  const now = new Date();

  if (now < startCountTime || now > openTime) {
    return 0;
  }

  return Math.ceil((openTime.getTime() - now.getTime()) / 1000);
};

export const setOrganizationLoading = bool => ({
  type: SET_ORGANIZATION_LOADING,
  payload: bool,
});

export const fetchAllCoveredWarrant = () => dispatch => {
  masterService.getAllCoveredWarrants().then(data => {
    const listCoveredWarrant = data.items.map(item => ({
      ...item,
      exchange: '',
      code: item.ticker,
      displayCode: item.coveredWarrantCode,
      codeName: item.coveredWarrantName,
      isCoveredWarrant: true,
    }));
    const {
      listId: listCoveredWarrantCode,
      listObjById: coveredWarrantDataByCode,
    } = getListIdAndListObjById(listCoveredWarrant, 'coveredWarrantCode');
    dispatch({
      type: SET_COVERED_WARRANT,
      payload: {
        listCoveredWarrantCode,
        coveredWarrantDataByCode,
        listCoveredWarrant,
      },
    });
  });
};

export const fetchOrganization = () => dispatch => {
  dispatch(setOrganizationLoading(true));
  masterService.getListOrganization().then(data => {
    dispatch(setOrganizationLoading(false));
    const listOrganizationSearch = formatListSearchTicker(formatData(data));

    const { listObjById } = getListIdAndListObjById(
      listOrganizationSearch,
      'organCode',
    );
    const { listObjById: listObjByTicker } = getListIdAndListObjById(
      listOrganizationSearch,
      'ticker',
    );

    dispatch({
      type: SET_ORGANIZATION,
      payload: {
        listOrganizationSearch,
        listOrganizationByOrganCode: listObjById,
        listOrganizationByTicker: listObjByTicker,
      },
    });
  });
};

export const fetchCompanyGroup = () => dispatch => {
  masterService.getAllCompanyGroup().then(data => {
    const listCompanyGroup = formatListIndex(formatData(data));
    const { listObjById } = getListIdAndListObjById(
      listCompanyGroup,
      'comGroupCode',
      { isIndex: true },
    );

    dispatch({
      type: SET_COMPANY_GROUP,
      payload: {
        listCompanyGroup,
        listCompanyGroupByComGroupCode: listObjById,
      },
    });
  });
};

export const fetchIndustry = () => dispatch => {
  masterService.getAllIcbIndustry().then(data => {
    const dataArr = cloneDeep(formatData(data));
    const listIndustry = formatDataIndustry(formatData(data));

    convertTreeMap(dataArr, 'industryID', 'parentIndustryID');
    const listIndustryByIcbLevel = groupBy(dataArr, 'icbLevel');

    const { listId, listObjById } = getListIdAndListObjById(
      listIndustry,
      'icbCode',
    );

    dispatch({
      type: SET_INDUSTRY,
      payload: {
        listIndustry,
        listIndustryByIcbLevel,
        listIcbCodeIndustry: listId,
        listIndustryByIcbCode: listObjById,
      },
    });
  });
};
export const fetchDerivative = () => dispatch => {
  masterService.getAllDerivatives().then(data => {
    const listDerivative = formatListDerivative(formatData(data));
    const { listObjById } = getListIdAndListObjById(
      listDerivative,
      'derivativeCode',
    );

    dispatch({
      type: SET_DERIVATIVE,
      payload: {
        listDerivative,
        listDerivativeByDerivativeCode: listObjById,
      },
    });
  });
};

export const fetchEconomy = () => dispatch => {
  masterService.getAllChartEconomy().then(data => {
    const listEconomy = formatData(data);
    const { listObjById } = getListIdAndListObjById(listEconomy, 'code');

    dispatch({
      type: SET_ECONOMY,
      payload: {
        listEconomy,
        listEconomyByEconomyCode: listObjById,
      },
    });
  });
};

export const fetchUserWatchlist = () => dispatch => {
  userSettingService.getUserWatchList().then(({ items }) => {
    dispatch({
      type: SET_USER_WATCHLIST,
      payload: items,
    });
  });
};

export const setSyncState = payload => ({
  payload,
  type: SET_SYNC_STATE,
});

function formatDataIndustry(data, icbLevel = 3) {
  return data.filter(item => {
    return item.icbLevel === icbLevel;
  });
}

function formatListSearchTicker(list) {
  let result = [];

  list.forEach(item => {
    result.push({
      ...item,
      displayCode: item.ticker,
      code: item.organCode,
      codeName: item.organShortName,
      exchange: formatComGroupCode(item.comGroupCode),
      isTicker: true,
      comTypeCode: item.comTypeCode,
      isBanking: checkIsBank(item.comTypeCode),
      isInsurance: checkIsInsurance(item.comTypeCode),
    });
  });

  return result;
}

function formatListDerivative(list) {
  let result = [];

  list.forEach(item => {
    result.push({
      ...item,
      displayCode: item.derivativeCode,
      code: item.derivativeCode,
      codeName: item.derivativeName,
      exchange: 'HNX',
      isDerivatives: true,
    });
  });

  return result;
}

function formatListIndex(list) {
  let result = [];

  list.forEach(item => {
    result.push({
      ...item,
      displayCode: item.comGroupCode,
      code: item.comGroupCode,
      codeName: item.comGroupName || item.comGroupCode,
      exchange: formatComGroupCode(item.parentComGroupCode),
      isTicker: false,
      isIndex: true,
    });
  });

  return result;
}

const initialState = {
  countListComponent: {},
  countListPopout: {},
  timeOffset: null,
  secondsToOpenMarket: getSecondsToOpenMarket(),

  isLoadingOrganization: false,
  listOrganizationSearch: [],
  listOrganizationByOrganCode: {},
  listOrganizationByTicker: {},

  listCoveredWarrant: [],
  listCoveredWarrantCode: [],
  coveredWarrantDataByCode: {},

  listCompanyGroup: [],
  listCompanyGroupByComGroupCode: {},

  listIndustry: [],
  listIcbCodeIndustry: [],
  listIndustryByIcbCode: {},

  listDerivative: [],
  listDerivativeByDerivativeCode: {},

  listEconomy: [],
  listEconomyByEconomyCode: {},

  syncComponent: {},
  syncComponentSearch: {},
  listUserWatchlist: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_COUNT_COMPONENT:
      const { nameComponent, count } = action.payload;

      return {
        ...state,
        countListComponent: {
          ...state.countListComponent,
          [nameComponent]:
            state.countListComponent[nameComponent] &&
            state.countListComponent[nameComponent] > 0
              ? state.countListComponent[nameComponent] + count
              : count,
        },
      };

    case CHANGE_COUNT_POPOUT:
      const { nameComponent: component, count: popoutCount } = action.payload;
      return {
        ...state,
        countListPopout: {
          ...state.countListPopout,
          [component]: state.countListPopout[component]
            ? state.countListPopout[component] + popoutCount
            : popoutCount,
        },
      };

    case GET_TIME_OFFSET_SUCCESS:
      return {
        ...state,
        timeOffset: action.payload,
      };
    case SET_TIME_TO_OPEN_MARKET:
      return {
        ...state,
        secondsToOpenMarket: action.payload,
      };
    case SET_ORGANIZATION_LOADING:
      return {
        ...state,
        isLoadingOrganization: action.payload,
      };
    case SET_COVERED_WARRANT:
    case SET_ORGANIZATION:
    case SET_COMPANY_GROUP:
    case SET_INDUSTRY:
    case SET_DERIVATIVE:
    case SET_ECONOMY:
      return {
        ...state,
        ...action.payload,
      };
    case SET_SYNC_COMPONENT:
      const { name, id, data } = action.payload;
      const newSyncComponent = {
        ...state.syncComponent,
        [name]: {
          ...(state.syncComponent[name] || {}),
          [id]: data,
        },
      };
      saveSyncComponentState(newSyncComponent);

      return {
        ...state,
        syncComponent: newSyncComponent,
      };

    case CHANGE_SYNC_COMPONENT_SEARCH:
      const syncComponentSearch = {
        ...state.syncComponentSearch,
        [action.payload.syncType]: action.payload.search,
      };
      setSyncComponentSearch(syncComponentSearch);
      return {
        ...state,
        syncComponentSearch,
      };
    case SET_USER_WATCHLIST:
      return {
        ...state,
        listUserWatchlist: action.payload,
      };
    case UPDATE_USER_WATCHLIST:
      return {
        ...state,
        listUserWatchlist: state.listUserWatchlist.concat(action.payload),
      };
    case DELETE_USER_WATCHLIST:
      return {
        ...state,
        listUserWatchlist: state.listUserWatchlist.filter(
          wl => wl.watchListId !== action.payload,
        ),
      };
    case SET_SYNC_STATE:
      saveSyncComponentState(action.payload.syncComponent);
      setSyncComponentSearch(action.payload.syncComponentSearch);
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
